"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const groupChatInfoTranslation = {
    info: "Info",
    members: "Members",
    vitals: "Vitals",
    settings: "Settings",
    labs: "Labs",
    patientDetails: "Patient Details",
    dateOfBirth: "Date of Birth:",
    episode: "Episode:",
    insurance: "Insurance:",
    sendEmailMessage: "Send emails to this group",
    getEmailMessage: "Get an email address that posts incoming emails in this group.",
    getEmailAddress: "Get Email Address",
    disableEmail: "Disable the email",
    copy: "Copy",
    copied: "Copied",
    referralInfo: "Referral Information",
    referralSource: "Referral Source",
    communityLiaison: "Community Liaison",
    tbd: "TBD",
    attachments: "Media, Links and Docs",
    about: "About",
    careEpisode: "Care Episode",
    startDate: "Start Date",
    endDate: "End Date",
    daysLeft: "Days Left",
    month: "Month",
    patientTitle: "Patient",
    caregiverTitle: "Caregiver",
    physicianDetails: "Physician Details",
    physicianName: "Physician Name",
    physicianNumber: "Physician Number",
    careGiverDetails: "Caregiver Details",
    careGiverName: "Caregiver Name",
    careGiverNumber: "Caregiver Number",
    pharmacyDetails: "Pharmacy Details",
    pharmacyName: "Pharmacy Name",
    pharmacyNumber: "Pharmacy Number",
    exportSettings: "Export Settings",
    newEpisode: "Start New Episode",
    newEpisodeExport: "Export",
    newEpisodeChatExport: "Export Chat",
    newEpisodeMediaExport: "Export Media",
    newEpisodeSkip: "Skip",
    newEpisodeContinue: "Continue",
    newEpisodeBack: "Back",
    newEpisodeWarningMessage: "Are you sure you don't want to export chat or media?",
    newEpisodeConfirmationTitle: "New Episode Confirmation",
    newEpisodeConfirmationMsg: "Are you sure you want to start new episode?",
    newEpisodeWarning: "Please note that once you start a new episode, you will not be able to go back. Also, chat and media will be exported automatically.",
    iHaveReadAndAgree: "I have read and agree",
    groupSettings: "Group Settings",
    visibility: "Visibility",
    dangerZone: "Danger Zone",
    groupMembers: "Group Members",
    search: "Search",
    addMembers: "Add Members",
    advancedSearch: "Advanced Search",
    selected: "Selected {{count}}",
    you: "You",
    me: "Me",
    pendingReferrals: "Pending Referrals",
    sent: "Sent",
    deleted: "Deleted",
    assignDevice: "Assign Devices",
    enterDeviceId: "Enter Device Id",
    noDevices: "No devices added",
    noDevicesAssigned: "No Devices Assigned",
    noDevicesDescription: "Assign a device to monitor patient vitals",
    muteNotifications: "Mute Notifications",
    visibleToPatient: "Visible To Patient",
    visibleToPhysician: "Visible To Physician",
    hideGroup: "Hide Group",
    manageNotifications: "Manage Other Notifications",
    leaveAndDeleteGroup: "Leave And Delete Group",
    hideChat: "Hide Chat",
    hideChatConfirmationMessage: "Are you sure you want to make this chat hidden ?",
    hideChatConfirmationButtonText: "OK",
    notifications: "Notifications",
    noMedia: "No Media, Links and Docs",
    patients: "Patients",
    physicians: "Physicians",
    clinicians: "Clinicians",
    office: "Office",
    admin: "Admin",
    patient: "patient",
    physician: "physician",
    clinician: "clinician",
    admins: "admins",
    userType: {
        USER: "Field Staff",
        APP: "App",
        STAFF: "Office Staff",
        ADMIN: "Admin",
        PHYSICIAN: "Physician",
        PATIENT: "Patient",
    },
    deleteMessage: "Delete Message",
    deleteGroup: "Delete Group",
    deleteBroadcast: "Delete Broadcast",
    confirmDeleteBroadcast: "Are you sure you want to delete this broadcast?",
    confirmDeleteGroup: "Are you sure you want to delete this group?",
    confirmDeleteMessage: "Are you sure you want to delete this message?",
    delete: "Delete",
    addBtn: "Add",
    mediaTitle: "Media",
    mediaHeaderTitle: "Media, Links and Docs",
    addPhysicianDetails: "Add Physician Details",
    weighingScale: "Weighing Scale",
    tapToViewVital: "Tap to view vital",
    voiceCallApp: "Voice Call on App",
    videoCallApp: "Video Call on App",
    callOnPhone: "Call on Phone Contact",
    cancel: "Cancel",
    yes: "Yes",
    openSettings: "Open Settings",
    careTimeline: {
        careTimeline: "Timeline",
        patient: "Patient",
        groupCreated: "Group Created",
        episode: "Episode",
        lupa: "Lupa",
        lupaThreshold: "LUPA Threshold",
        templateFilledBy: "{{userName}} filled {{templateName}} Form Details:",
        reason: "Reason: ",
        lupaCriteria: {
            met: "Met",
            partiallyMet: "Partially Met",
            notMet: "Not Met",
            notAvailable: "Not Available",
        },
        careSummary: "Care Summary",
        careEpisode: "Care Episode",
        activityTimeline: "Activity Timeline",
        patientGroupCreated: "Patient group created",
        updatedPatientStatus: "{{userName}} updated patient status",
        filledForm: "{{userName}} filled {{formName}} form",
        before: "Before",
        after: "After",
        first30Days: "1st 30 days",
        second30Days: "2nd 30 days",
        eventTypes: {
            system: "System",
            statusChange: "Status Change",
            form: "Form",
        },
    },
    assignDevices: {
        alertDeviceId: "Device ID :",
        scanQRCodeOrEnterId: "Scan the QR code on your new device or enter device id below to register.",
        rpmDeviceUpdated: "Rpm device patient group updated successfully.",
        deviceAssignedSuccessfully: "Device Assigned Successfully",
        deviceRemovedSuccessfully: "Device Removed Successfully",
        unableToAssignDevice: "Unable to Assign Device",
        unableToRemoveDevice: "Unable to Remove Device",
        DEVICE_ALREADY_ASSIGNED_TO_SAME_PATIENT_GROUP: "Device already assigned to current patient. Kindly check device id and try again.",
        DEVICE_ALREADY_ASSIGNED: "Device assigned to another patient.\nAre you sure you want to assign it to this patient?",
        INVALID_DEVICE_ID: "Invalid RPM device id(s) provided, kindly check and try again.",
        UNKNOWN_ERROR: "Unknown error occurred while assigning device. Kindly check device id and try again.",
        errorManagingDevice: "Error managing device. Kindly check device id and try again.",
    },
    chatInfoLoading: "Loading chat info, please wait a moment",
    removeMemberTitle: "Remove Member Confirmation",
    confirmRemoveMember: "Are you sure you want to remove this member?",
    remove: "Remove",
    removeMember: "Remove Member",
};
exports.default = groupChatInfoTranslation;
